var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .15h15v14.858H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5092B",
    d: "M7.5 1.636c3.314 0 6 2.66 6 5.943 0 3.283-2.686 5.944-6 5.944s-6-2.661-6-5.944c0-3.282 2.686-5.943 6-5.943zm0 .743c-2.9 0-5.25 2.328-5.25 5.2 0 2.872 2.35 5.2 5.25 5.2s5.25-2.328 5.25-5.2c0-2.872-2.35-5.2-5.25-5.2zm.006 7.305a.371.371 0 0 1 .068.737l-.068.006a.374.374 0 0 1-.381-.371c0-.183.133-.334.308-.366l.073-.006zM7.5 4.731c.184 0 .337.132.369.305l.006.067v2.476a.375.375 0 0 1-.744.067l-.006-.067V5.103c0-.205.168-.372.375-.372z"
  }))));
};
export default SvgError;